import Stockallot from './boss/stockallot'
import Shipment from './boss/shipment'
import B2corder from './boss/b2corder'
import Inventory from './boss/inventory'
import Products from './boss/products'
import Errorder from './boss/errorder'
import B2Border from './boss/b2border'
import Cost from './boss/cost'
import Distribution from './boss/distribution'
import department from './department'

import Allotment from './allotment'
import Sfp from './sfp'
import Managechannel from './managechannel'
import Aftersales from './aftersales'
import Manage from './manage'
import Setting from './setting'

import Purchase from './purchase'
import Proddevelop from './proddevelop'
import Rules from './rules'
import Intercept from './intercept'

import StockDistribution from './stockdistribution'
import SkuSales from "./skusales"


export default [
    {   //组面板
        path: "",
        name: "homePanel",
        component: () => import(/* webpackChunkName: "home" */ "@components/homepage/home.vue"),
        meta: {
            bread: false
        }
    },
    {   //公告列表
        path: "/homenewlist",
        name: "homenewList",
        component: () => import(/* webpackChunkName: "home" */ "@components/homepage/homelist/newslist"),
        // meta: {
        //     bread: false
        // }
    },
    ...Stockallot,
    ...Shipment,
    ...B2corder,
    ...Inventory,
    ...Products,
    ...Errorder,
    ...Sfp,
    ...Managechannel,
    ...B2Border,
    ...Allotment,
    ...Aftersales,
    ...Manage,
    ...Cost,
    ...Setting,
    ...Purchase,
    ...Proddevelop,
    ...Distribution,
    ...Rules,
    ...Intercept,
    ...StockDistribution,
    ...department,
    ...SkuSales
]
